// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.__streaming_container {
  z-index: 1;
  height: calc(100% - 60px);
  width: 100%;
  margin: 0;
  background-color: #000000;
  position: fixed;
  bottom: 0;
  border-radius: 12px;
  transition: all 0.1s ease;
  display: flex;
  flex-direction: column;
}
.__streaming_container ._streaming_canvas {
  display: flex;
  flex-direction: row; /* Layout the children side by side */
  height: 95%; /* Ensure it takes the full height of the parent container */
  width: 100%;
}
.__streaming_container ._streaming_canvas .local_stream_container, .__streaming_container ._streaming_canvas .remote_stream_container {
  display: grid;
  position: relative;
  background: #000000;
  width: 70%; /* Increase the width to make the stream container larger */
  height: 100%; /* Full height within the parent container */
  margin-right: 16px; /* Space between stream and audience */
}
.__streaming_container ._streaming_canvas .local_stream_container ._no_video, .__streaming_container ._streaming_canvas .remote_stream_container ._no_video {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  object-fit: contain;
  display: flex;
  transition: all 0.1s ease-out;
  left: 0;
  right: 0;
  bottom: 0;
}
.__streaming_container ._streaming_canvas .local_stream_container ._no_video img, .__streaming_container ._streaming_canvas .remote_stream_container ._no_video img {
  max-width: 160px;
  max-height: 160px;
  width: 100%;
  height: 100%;
  margin: auto;
  object-fit: cover;
}
.__streaming_container ._streaming_canvas .local_stream_container ._video_screen, .__streaming_container ._streaming_canvas .remote_stream_container ._video_screen {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Make sure the video fills the container without distortion */
}
.__streaming_container ._streaming_canvas .local_stream_container ._share_screen, .__streaming_container ._streaming_canvas .remote_stream_container ._share_screen {
  width: 160px;
  height: 120px;
  position: absolute;
  z-index: 2;
  bottom: 0;
  right: 0;
}
.__streaming_container ._streaming_canvas .remote_stream_container {
  display: flex;
  position: relative;
}
.__streaming_container ._streaming_canvas .remote_stream_container ._no_video {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  object-fit: contain;
  display: flex;
  transition: all 0.1s ease-out;
  left: 0;
  right: 0;
  bottom: 0;
}
.__streaming_container ._streaming_canvas .remote_stream_container ._no_video img {
  max-width: 160px;
  max-height: 160px;
  margin: auto;
  object-fit: cover;
}
.__streaming_container ._streaming_canvas .remote_stream_container ._video_screen {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Make sure the video fills the container without distortion */
}
.__streaming_container ._streaming_canvas .remote_stream_container ._share_screen {
  width: 160px;
  height: 120px;
  position: absolute;
  z-index: 1;
  bottom: 0;
  right: 0;
}
.__streaming_container ._streaming_canvas #remote_video_ {
  position: relative;
  z-index: 1;
  display: flex;
}
.__streaming_container ._streaming_canvas #remote_video_ ._video_small {
  width: 160px;
  height: 120px;
  position: absolute;
  right: 0;
  bottom: 0;
}
.__streaming_container ._streaming_canvas #remote_video_ ._video_large {
  width: 100%;
  height: 100%;
  position: relative;
}
.__streaming_container ._streaming_canvas ._streaming_audience {
  overflow: auto; /* Maintain scrollbars when needed */
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 108px; /* Fixed width for the audience list */
  height: calc(100% - 100px);
  position: relative; /* Keep its position fixed relative to the container */
  z-index: 10;
  background: linear-gradient(to top, #000000, transparent); /* Match chat gradient */
  border-radius: 16px 0 0 0; /* Adjust borders to your liking */
  padding: 16px; /* Add padding for spacing */
  flex-shrink: 0; /* Prevent the audience box from shrinking */
}
.__streaming_container ._streaming_canvas ._streaming_audience ._streaming_audience_box {
  position: relative;
  max-height: 108px;
  background: transparent;
}
.__streaming_container ._streaming_canvas ._streaming_audience ._streaming_audience_box ._streaming_audience_box_image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.__streaming_container ._streaming_canvas ._streaming_audience ._streaming_audience_box ._streaming_audience_box_user_detail {
  position: absolute;
  top: 0;
  align-items: center;
  padding: 5px;
}
.__streaming_container ._streaming_canvas ._streaming_audience ._streaming_audience_box ._streaming_audience_box_user_detail ._online {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #2CF488;
}
.__streaming_container ._streaming_canvas ._streaming_audience ._streaming_audience_box_more {
  cursor: pointer;
  width: 108px;
  background-color: transparent;
  height: 108px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.__streaming_container ._remote_sttreaming_canvas ._no_video {
  width: 85%;
  height: calc(100% - 126px);
  position: absolute;
  top: 0;
  object-fit: contain;
  display: flex;
  transition: all 0.1s ease-out;
}
.__streaming_container ._remote_sttreaming_canvas ._no_video img {
  max-width: 160px;
  max-height: 160px;
  margin: auto;
  object-fit: cover;
}
.__streaming_container ._streaming_header {
  padding: 8px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.0980392157);
}
.__streaming_container ._streaming_header ._streaming_header_container span {
  width: 30px;
  height: 8px;
  background: #E3293E;
  border-radius: 50%;
}
.__streaming_container ._streaming_control {
  display: flex;
  padding: 16px;
  gap: 5px;
  height: 40px;
  position: relative;
}
.__streaming_container ._streaming_control .streaming_control_box {
  display: flex;
  gap: 5px;
}
.__streaming_container ._streaming_control .streaming_control_box .btn {
  width: 30px;
  height: 30px;
  background-color: #353535;
}
.__streaming_container ._streaming_control .streaming_control_box .btn .icon {
  font-size: 18px;
}
.__streaming_container ._streaming_chat {
  border-bottom-left-radius: 16px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
  min-height: 600px;
  height: 100%;
  width: 300px;
  padding: 16px;
  background: linear-gradient(to top, #000000, transparent);
}
.__streaming_container ._streaming_chat ._streaming_chat_messages {
  display: grid;
  grid-template-rows: repeat(auto-fill, minmax(min-content, max-content));
  overflow-y: auto;
  height: calc(100% - 50px);
  opacity: 0.7;
}
.__streaming_container ._streaming_chat ._hide_messages {
  height: 0;
}
.__streaming_container ._streaming_chat ._streaming_chat_input {
  justify-content: space-between;
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 15px;
}
.__streaming_container ._streaming_chat ._streaming_chat_input input {
  background: #000000;
  width: 80%;
  border: 0;
  color: #FFFFFF;
}
.__streaming_container ._streaming_chat ._arrow_down_chat {
  transform: rotate(180deg);
  transition: transform 0.2s;
}
.__streaming_container ._streaming_chat ._arrow_up_chat {
  transform: rotate(0deg);
  transition: transform 0.2s;
}
.__streaming_container ._raised_list {
  z-index: 1;
  right: 113px;
  bottom: 56px;
  background: #1e1e1e;
  width: 333px;
  min-height: 200px;
  border-radius: 16px;
  box-shadow: 0px 0px 5px 1px #181818;
  padding: 10px;
  max-height: 400px;
  overflow: auto;
}
.__streaming_container ._streaming_box {
  box-shadow: 0px -6px 12px rgba(0, 0, 0, 0.3019607843);
  border: 1px solid #999999;
  padding: 20px;
  height: 92%;
  position: relative;
}
.__streaming_container ._streaming_box ._streaming_videos {
  height: 90%;
  align-self: flex-start;
  display: grid;
  grid-template-columns: auto auto auto auto;
  justify-items: center;
  align-items: center;
  gap: 10px;
}
.__streaming_container ._streaming_box ._streaming_videos .vid {
  position: relative;
  background-color: black;
  border-width: 1px;
  border-color: #38373a;
  border-style: solid;
  height: 100%;
  width: 100%;
  border: 1px solid #707070;
}
.__streaming_container ._streaming_box ._streaming_videos .vid:first-child {
  grid-column: 1/4;
  grid-row: 1/4;
}
.__streaming_container ._streaming_box .controls {
  width: 94%;
  height: 33px;
  justify-content: space-between;
  display: flex;
  position: absolute;
  bottom: 5px;
}
.__streaming_container ._streaming_box .controls ._streaming_icons {
  color: #999999;
  font-size: 20px;
  cursor: pointer;
}
.__streaming_container ._streaming_box .controls ._streaming_icons:hover {
  color: #ffffff;
}
.__streaming_container .image-upload-container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 10px;
}
.__streaming_container .image-upload-container #uploadButton {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.__streaming_container .image-upload-container #uploadButton:hover {
  background-color: #0056b3;
}
.__streaming_container .image-upload-container .image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.__streaming_container .image-upload-container .image-overlay img {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
}
.__streaming_container .image-upload-container .image-overlay .waveform-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #181818;
  padding: 10px;
  margin-bottom: 15px;
}
.__streaming_container .image-upload-container .image-overlay .waveform-container div {
  width: 100%;
  height: 80px;
}
.__streaming_container .image-upload-container .image-overlay .waveform-container .song-title {
  color: #ffffff;
  font-size: 16px;
  margin-left: 15px;
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/pages/Streaming/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AAzBA;EACI,UAAA;EACA,yBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;AA2BJ;AAzBI;EACI,aAAA;EACA,mBAAA,EAAA,qCAAA;EACA,WAAA,EAAA,4DAAA;EACA,WAAA;AA2BR;AAzBQ;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA,EAAA,2DAAA;EACA,YAAA,EAAA,4CAAA;EACA,kBAAA,EAAA,sCAAA;AA2BZ;AAzBY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AA2BhB;AAzBgB;EACI,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AA2BpB;AAtBY;EACI,WAAA;EACA,YAAA;EACA,iBAAA,EAAA,+DAAA;AAwBhB;AApBY;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;AAsBhB;AAlBQ;EACI,aAAA;EACA,kBAAA;AAoBZ;AAlBY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAoBhB;AAlBgB;EACI,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AAoBpB;AAfY;EACI,WAAA;EACA,YAAA;EACA,iBAAA,EAAA,+DAAA;AAiBhB;AAbY;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;AAehB;AAXQ;EACI,kBAAA;EACA,UAAA;EACA,aAAA;AAaZ;AAXY;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAahB;AAVY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAYhB;AANQ;EACI,cAAA,EAAA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA,EAAA,sCAAA;EACA,0BAAA;EACA,kBAAA,EAAA,sDAAA;EACA,WAAA;EACA,yDAAA,EAAA,wBAAA;EACA,yBAAA,EAAA,kCAAA;EACA,aAAA,EAAA,4BAAA;EACA,cAAA,EAAA,4CAAA;AAQZ;AANY;EACI,kBAAA;EACA,iBAAA;EACA,uBAAA;AAQhB;AANgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAQpB;AALgB;EACI,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,YAAA;AAOpB;AALoB;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AAOxB;AAFY;EAEI,eAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGhB;AAIQ;EACI,UAAA;EACA,0BAAA;EACA,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;AAFZ;AAIY;EACI,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AAFhB;AASI;EACI,iBAAA;EACA,0DAAA;AAPR;AAUY;EACI,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AARhB;AAaI;EACI,aAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;AAXR;AAaQ;EACI,aAAA;EACA,QAAA;AAXZ;AAaY;EACI,WAAA;EACA,YAAA;EACA,yBAAA;AAXhB;AAagB;EACI,eAAA;AAXpB;AAiBI;EACI,+BAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,yDAAA;AAfR;AAiBQ;EACI,aAAA;EACA,uEAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AAfZ;AAkBQ;EACI,SAAA;AAhBZ;AAmBQ;EACI,8BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAjBZ;AAmBY;EACI,mBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;AAjBhB;AAqBQ;EACI,yBAAA;EACA,0BAAA;AAnBZ;AAsBQ;EACI,uBAAA;EACA,0BAAA;AApBZ;AAwBI;EACI,UAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,mCAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AAtBR;AAyBI;EACI,qDAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;AAvBR;AAyBQ;EACI,WAAA;EACA,sBAAA;EACA,aAAA;EACA,0CAAA;EACA,qBAAA;EACA,mBAAA;EACA,SAAA;AAvBZ;AAyBY;EACI,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AAvBhB;AA0BY;EACI,gBAAA;EACA,aAAA;AAxBhB;AA4BQ;EACI,UAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AA1BZ;AA4BY;EACI,cAAA;EACA,eAAA;EACA,eAAA;AA1BhB;AA4BgB;EACI,cAAA;AA1BpB;AAgCI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,SAAA;AA9BR;AAgCQ;EACI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AA9BZ;AAgCY;EACI,yBAAA;AA9BhB;AAkCQ;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAhCZ;AAkCY;EACI,cAAA;EACA,eAAA;EACA,mBAAA;AAhChB;AAmCY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AAjChB;AAoCc;EACE,WAAA;EACA,YAAA;AAlChB;AAqCc;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AAnChB","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"./../../styles/mixins\";\n\n\n.__streaming_container {\n    z-index: 1;\n    height: calc(100% - 60px); // Adjust based on your header or other fixed elements\n    width: 100%; // Make the container full width\n    margin: 0;\n    background-color: #000000;\n    position: fixed;\n    bottom: 0;\n    border-radius: 12px;\n    transition: all 0.1s ease;\n    display: flex;\n    flex-direction: column;\n\n    ._streaming_canvas {\n        display: flex;\n        flex-direction: row; /* Layout the children side by side */\n        height: 95%; /* Ensure it takes the full height of the parent container */\n        width: 100%;\n\n        .local_stream_container, .remote_stream_container {\n            display: grid;\n            position: relative;\n            background: #000000;\n            width: 70%; /* Increase the width to make the stream container larger */\n            height: 100%; /* Full height within the parent container */\n            margin-right: 16px; /* Space between stream and audience */\n\n            ._no_video {\n                width: 100%;\n                height: 100%;\n                position: absolute;\n                top: 0;\n                object-fit: contain;\n                display: flex;\n                transition: all 0.1s ease-out;\n                left: 0;\n                right: 0;\n                bottom: 0;\n\n                img {\n                    max-width: 160px;\n                    max-height: 160px;\n                    width: 100%;\n                    height: 100%;\n                    margin: auto;\n                    object-fit: cover;\n                }\n\n            }\n\n            ._video_screen {\n                width: 100%;\n                height: 100%;\n                object-fit: cover; /* Make sure the video fills the container without distortion */\n\n            }\n\n            ._share_screen {\n                width: 160px;\n                height: 120px;\n                position: absolute;\n                z-index: 2;\n                bottom: 0;\n                right: 0;\n            }\n        }\n\n        .remote_stream_container {\n            display: flex;\n            position: relative;\n\n            ._no_video {\n                width: 100%;\n                height: 100%;\n                position: absolute;\n                top: 0;\n                object-fit: contain;\n                display: flex;\n                transition: all 0.1s ease-out;\n                left: 0;\n                right: 0;\n                bottom: 0;\n\n                img {\n                    max-width: 160px;\n                    max-height: 160px;\n                    margin: auto;\n                    object-fit: cover;\n                }\n\n            }\n\n            ._video_screen {\n                width: 100%;\n                height: 100%;\n                object-fit: cover; /* Make sure the video fills the container without distortion */\n\n            }\n\n            ._share_screen {\n                width: 160px;\n                height: 120px;\n                position: absolute;\n                z-index: 1;\n                bottom: 0;\n                right: 0;\n            }\n        }\n\n        #remote_video_ {\n            position: relative;\n            z-index: 1;\n            display: flex;\n\n            ._video_small {\n                width: 160px;\n                height: 120px;\n                position: absolute;\n                right: 0;\n                bottom: 0;\n            }\n\n            ._video_large {\n                width: 100%;\n                height: 100%;\n                position: relative;\n\n            }\n\n        }\n\n        ._streaming_audience {\n            overflow: auto; /* Maintain scrollbars when needed */\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n            width: 108px; /* Fixed width for the audience list */\n            height: calc(100% - 100px);\n            position: relative; /* Keep its position fixed relative to the container */\n            z-index: 10;\n            background: linear-gradient(to top, #000000, transparent); /* Match chat gradient */\n            border-radius: 16px 0 0 0; /* Adjust borders to your liking */\n            padding: 16px; /* Add padding for spacing */\n            flex-shrink: 0; /* Prevent the audience box from shrinking */\n\n            ._streaming_audience_box {\n                position: relative;\n                max-height: 108px;\n                background: transparent;\n                \n                ._streaming_audience_box_image {\n                    width: 100%;\n                    height: 100%;\n                    object-fit: cover;\n                    border-radius: 50%\n                }\n\n                ._streaming_audience_box_user_detail {\n                    position: absolute;\n                    top: 0;\n                    align-items: center;\n                    padding: 5px;\n\n                    ._online {\n                        width: 7px;\n                        height: 7px;\n                        border-radius: 50%;\n                        background-color: #2CF488;\n                    }\n                }\n            }\n\n            ._streaming_audience_box_more {\n\n                cursor: pointer;\n                width: 108px;\n                background-color: transparent; // Make the background transparent\n                height: 108px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n\n            }\n        }\n    }\n\n    ._remote_sttreaming_canvas {\n        ._no_video {\n            width: 85%;\n            height: calc(100% - 126px);\n            position: absolute;\n            top: 0;\n            object-fit: contain;\n            display: flex;\n            transition: all 0.1s ease-out;\n\n            img {\n                max-width: 160px;\n                max-height: 160px;\n                margin: auto;\n                object-fit: cover;\n\n            }\n\n        }\n    }\n\n    ._streaming_header {\n        padding: 8px 16px;\n        border-bottom: 1px solid #FFFFFF19;\n\n        ._streaming_header_container {\n            span {\n                width: 30px;\n                height: 8px;\n                background: #E3293E;\n                border-radius: 50%;\n            }\n        }\n    }\n    \n    ._streaming_control {\n        display: flex;\n        padding: 16px;\n        gap: 5px;\n        height: 40px;\n        position: relative; // Adjust position for control elements\n\n        .streaming_control_box {\n            display: flex;\n            gap: 5px;\n\n            .btn {\n                width: 30px;\n                height: 30px;\n                background-color: #353535;\n\n                .icon {\n                    font-size: 18px;\n                }\n            }\n        }\n    }\n\n    ._streaming_chat {\n        border-bottom-left-radius: 16px;\n        position: absolute; // Changed to absolute to overlap the video container\n        bottom: 0;\n        left: 0;\n        z-index: 2; // Higher z-index to ensure it appears above the video\n        min-height: 600px;\n        height: 100%;\n        width: 300px; // Adjusted width\n        padding: 16px;\n        background: linear-gradient(to top, #000000, transparent);\n\n        ._streaming_chat_messages {\n            display: grid;\n            grid-template-rows: repeat(auto-fill, minmax(min-content, max-content));\n            overflow-y: auto; // Use auto to show scrollbars only when needed\n            height: calc(100% - 50px);\n            opacity: 0.7;\n        }\n\n        ._hide_messages {\n            height: 0;\n        }\n\n        ._streaming_chat_input {\n            justify-content: space-between;\n            width: 100%;\n            height: 36px;\n            display: flex;\n            align-items: center;\n            position: absolute;\n            bottom: 15px;\n\n            input {\n                background: #000000;\n                width: 80%;\n                border: 0;\n                color: #FFFFFF;\n            }\n        }\n\n        ._arrow_down_chat {\n            transform: rotate(180deg);\n            transition: transform .2s;\n        }\n\n        ._arrow_up_chat {\n            transform: rotate(0deg);\n            transition: transform .2s;\n        }\n    }\n\n    ._raised_list {\n        z-index: 1;\n        right: 113px;\n        bottom: 56px;\n        background: #1e1e1e;\n        width: 333px;\n        min-height: 200px;\n        border-radius: 16px;\n        box-shadow: 0px 0px 5px 1px #181818;\n        padding: 10px;\n        max-height: 400px;\n        overflow: auto; // Use auto to show scrollbars only when needed\n    }\n\n    ._streaming_box {\n        box-shadow: 0px -6px 12px #0000004d;\n        border: 1px solid #999999;\n        padding: 20px;\n        height: 92%;\n        position: relative;\n\n        ._streaming_videos {\n            height: 90%;\n            align-self: flex-start;\n            display: grid;\n            grid-template-columns: auto auto auto auto;\n            justify-items: center;\n            align-items: center;\n            gap: 10px;\n\n            .vid {\n                position: relative;\n                background-color: black;\n                border-width: 1px;\n                border-color: #38373a;\n                border-style: solid;\n                height: 100%;\n                width: 100%;\n                border: 1px solid #707070;\n            }\n\n            .vid:first-child {\n                grid-column: 1/4;\n                grid-row: 1 / 4;\n            }\n        }\n\n        .controls {\n            width: 94%;\n            height: 33px;\n            justify-content: space-between;\n            display: flex;\n            position: absolute;\n            bottom: 5px;\n\n            ._streaming_icons {\n                color: #999999;\n                font-size: 20px;\n                cursor: pointer;\n\n                &:hover {\n                    color: #ffffff\n                }\n            }\n        }\n    }\n\n    .image-upload-container {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-end; // Ensure button is at the bottom\n        gap: 10px; // Space between button and other controls\n\n        #uploadButton {\n            background-color: #007bff;\n            color: white;\n            border: none;\n            border-radius: 5px;\n            padding: 10px 20px;\n            cursor: pointer;\n            position: absolute;\n            bottom: 20px; // Adjust based on layout\n            right: 20px; // Adjust based on layout\n\n            &:hover {\n                background-color: #0056b3;\n            }\n        }\n\n        .image-overlay {\n            position: fixed; // Use fixed to overlay the entire screen\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            background-color: rgba(0, 0, 0, 0.7); // Slightly darker to highlight the image\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            z-index: 1000; // Ensure it's on top of other elements\n\n            img {\n                max-width: 90%;\n                max-height: 90%;\n                object-fit: contain;\n            }\n\n            .waveform-container {\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                background-color: #181818;\n                padding: 10px;\n                margin-bottom: 15px;\n              }\n              \n              .waveform-container div {\n                width: 100%;\n                height: 80px;\n              }\n              \n              .waveform-container .song-title {\n                color: #ffffff;\n                font-size: 16px;\n                margin-left: 15px;\n              }\n              \n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
